module.exports = __webpack_public_path__ + "static/Waikiki Aquarium.708a7b53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Waikiki Aquarium.jpg
// module id = 489
// module chunks = 35783957827783